import { HtsClassificationTopic, HtsTopicKind } from "../constants";
import { HtsClassificationTopicConfig } from "../schemas";

// Section E closing questions — probed when vague, exactly like Section D,
// but coaching content rather than a scored pillar: the seeded Section E
// questions carry no `readinessPillars`, so htsReadinessScoring.ts never sees
// these answers at all. Only htsReadinessFollowUp.ts gently probes them for
// the coach's benefit.
export const selfAwareness: HtsClassificationTopicConfig = {
  id: HtsClassificationTopic.SELF_AWARENESS,
  label: "Self-awareness",
  kind: HtsTopicKind.Readiness,
  narrativeFields: [
    "what the candidate is most proud of, and why",
    "whether anyone from their work/volunteer history wouldn't give them a positive reference, and why",
  ],
  followUpTriggers: [
    "a \"yes\" to the negative-reference question has no explanation",
  ],
  hardBarrierFacts: [],
};
